import React from 'react';

// Components
import ModalV2 from '@/views/components/modals/ModalV2';
import { formatMessage } from '@/utils/i18n';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
  showModal: boolean;
  contactName: string;
};

const LinkContactConfirmationModal = (props: Props) => {
  const { onCancel, onConfirm, showModal, contactName } = props;
  const i18nBasePath = 'Planning.Conquest.AssignContactPage.LinkContactConfirmationModal';

  return (
    <ModalV2
      show={showModal}
      title={`${i18nBasePath}.Title`}
      body={formatMessage(`${i18nBasePath}.Message`, { contactName })}
      onClose={props.onCancel}
      modalClassName="body-md"
      defaultFooterButtons={{
        cancelLabelToLocalize: 'Common.Cancel',
        cancelOnClick: onCancel,
        primaryLabelToLocalize: `${i18nBasePath}.ConfirmLink`,
        primaryOnClick: onConfirm,
      }}
    />
  );
};

export default LinkContactConfirmationModal;
